(function () {
  var bar = document.querySelector('[data-as-sticky-buy]');
  if (!bar) return;

  var sectionId = bar.dataset.sectionId;
  var info = document.querySelector('product-info');
  var mq = window.matchMedia('(max-width: 749px)');
  var priceEl = bar.querySelector('[data-as-price]');
  var optionsEl = bar.querySelector('[data-as-options]');
  var button = bar.querySelector('[data-as-button]');
  var label = bar.querySelector('[data-as-label]');
  var root = document.documentElement;
  var realButton = null;
  var offscreen = false;
  var io = null;
  var queued = false;

  function priceText() {
    var box = document.getElementById('price-' + sectionId);
    if (!box) return '';
    var onSale = box.querySelector('.price--on-sale');
    var item = onSale
      ? box.querySelector('.price__sale .price-item--sale')
      : box.querySelector('.price__regular .price-item--regular');
    if (!item) return '';
    var clone = item.cloneNode(true);
    clone.querySelectorAll('.price-local-estimate').forEach(function (n) {
      n.remove();
    });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function optionsText() {
    var values = [];
    if (!info) return '';
    info.querySelectorAll('variant-selects input[type="radio"]:checked').forEach(function (i) {
      values.push(i.value);
    });
    info.querySelectorAll('variant-selects select').forEach(function (s) {
      if (s.selectedOptions[0]) values.push(s.selectedOptions[0].textContent.trim());
    });
    return values.join(' / ');
  }

  function setVisible(show) {
    bar.classList.toggle('is-visible', show);
    button.tabIndex = show ? 0 : -1;
    root.classList.toggle('as-sticky-buy-on', show);
    if (show) root.style.setProperty('--as-sticky-h', bar.offsetHeight + 'px');
  }

  function observeReal() {
    var current = document.getElementById('ProductSubmitButton-' + sectionId);
    if (current === realButton) return;
    if (io) io.disconnect();
    realButton = current;
    if (!realButton || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(function (entries) {
      offscreen = !entries[0].isIntersecting;
      setVisible(offscreen && mq.matches);
    });
    io.observe(realButton);
  }

  function sync() {
    queued = false;
    observeReal();
    priceEl.textContent = priceText();
    optionsEl.textContent = optionsText();
    if (realButton) {
      var text = realButton.querySelector('span');
      if (text) label.textContent = text.textContent.replace(/\s+/g, ' ').trim();
      button.disabled = realButton.hasAttribute('disabled');
      var busy = realButton.getAttribute('aria-disabled') === 'true' || realButton.classList.contains('loading');
      if (busy) button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
    }
    setVisible(offscreen && mq.matches);
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }

  if (info) {
    new MutationObserver(function (mutations) {
      if (mutations.some(function (m) { return !bar.contains(m.target); })) queue();
    }).observe(info, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class', 'checked'],
    });
    info.addEventListener('change', queue);
  }

  button.addEventListener('click', function (e) {
    if (button.getAttribute('aria-disabled') === 'true') e.preventDefault();
  });

  if (mq.addEventListener) mq.addEventListener('change', queue);
  window.addEventListener('resize', queue);
  sync();
})();
